var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_452_76)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_452_76",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5542 5.73541V13.2271C29.5542 14.2417 29.9584 15.2167 30.6792 15.9354C31.4019 16.6549 32.3802 17.0587 33.4 17.0583H41.9938"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.0542 5.73541C31.0542 4.90699 30.3826 4.23541 29.5542 4.23541C28.7258 4.23541 28.0542 4.90699 28.0542 5.73541H29.5542H31.0542ZM30.6792 15.9354L29.6201 16.9976L29.6209 16.9984L30.6792 15.9354ZM33.4 17.0583V15.5583L33.3995 15.5583L33.4 17.0583ZM41.9938 18.5583C42.8222 18.5583 43.4938 17.8868 43.4938 17.0583C43.4938 16.2299 42.8222 15.5583 41.9938 15.5583V17.0583V18.5583ZM29.5542 5.73541H28.0542V13.2271H29.5542H31.0542V5.73541H29.5542ZM29.5542 13.2271H28.0542C28.0542 14.6404 28.6171 15.9976 29.6201 16.9976L30.6792 15.9354L31.7383 14.8732C31.2996 14.4358 31.0542 13.8429 31.0542 13.2271H29.5542ZM30.6792 15.9354L29.6209 16.9984C30.6248 17.9979 31.9839 18.5589 33.4006 18.5583L33.4 17.0583L33.3995 15.5583C32.7766 15.5586 32.179 15.3119 31.7375 14.8724L30.6792 15.9354ZM33.4 17.0583V18.5583H41.9938V17.0583V15.5583H33.4V17.0583Z",
    fill: "#FFAE00",
    mask: "url(#path-1-inside-1_452_76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0029 6.98291H28.959C30.3706 6.97802 31.7363 7.46795 32.8213 8.36182L33.0342 8.54541L39.1934 14.2095C39.2033 14.2186 39.2134 14.228 39.2236 14.2368C39.7486 14.6891 40.1725 15.2467 40.4678 15.8735C40.763 16.5004 40.9232 17.1827 40.9375 17.8755V35.6714C40.9001 36.6687 40.667 37.6489 40.251 38.5562C39.8327 39.4682 39.2377 40.2881 38.501 40.9692L38.5 40.9712C37.7619 41.6563 36.8954 42.1892 35.9512 42.5396C35.0071 42.8899 34.0033 43.0509 32.9971 43.0132L32.9502 43.0122H17.1377L17.0801 43.0142C16.0669 43.0604 15.0541 42.9058 14.1006 42.5601C13.1471 42.2143 12.2705 41.6834 11.5225 40.9985C10.7792 40.3156 10.1793 39.4914 9.75684 38.5747C9.33631 37.6621 9.1004 36.6754 9.0625 35.6714V14.3237C9.09997 13.3268 9.33316 12.3469 9.74902 11.4399C10.1673 10.5279 10.7623 9.70706 11.499 9.02588L11.5 9.0249C12.2382 8.33978 13.1046 7.80595 14.0488 7.45557C14.9929 7.1053 15.9967 6.94521 17.0029 6.98291ZM15.9316 32.8188C15.2413 32.8188 14.6816 33.3785 14.6816 34.0688C14.6817 34.7591 15.2413 35.3188 15.9316 35.3188H34.0684C34.7587 35.3188 35.3183 34.7591 35.3184 34.0688C35.3184 33.4215 34.8268 32.8886 34.1963 32.8247L34.0684 32.8188H15.9316ZM15.9316 23.7495C15.2414 23.7495 14.6819 24.3094 14.6816 24.9995C14.6816 25.6899 15.2413 26.2495 15.9316 26.2495H34.0684C34.7587 26.2495 35.3184 25.6899 35.3184 24.9995C35.3181 24.3094 34.7586 23.7495 34.0684 23.7495H15.9316ZM15.9316 14.6812C15.2413 14.6812 14.6817 15.2408 14.6816 15.9312C14.6816 16.6215 15.2413 17.1812 15.9316 17.1812H22.7334C23.4237 17.1811 23.9834 16.6215 23.9834 15.9312C23.9834 15.2841 23.4915 14.7521 22.8613 14.688L22.7334 14.6812H15.9316Z",
    stroke: "#FFAE00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_452_76",
    x: 3.8125,
    y: 1.72705,
    width: 42.375,
    height: 46.5447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_452_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_452_76",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.4837540d5a979c745762e59f3e5ca310.svg";
export { ForwardRef as ReactComponent };